import React from "react";
import { Fab, Tooltip } from "@mui/material";
import { Login } from "@mui/icons-material";

export default function PATDownButton(props) {
	const { onClick, disabled, size, tooltipText } = props;

	return (
		<Tooltip title={tooltipText || "Down"}>
			<Fab
				size="small"
				disabled={disabled}
				color="secondary"
				aria-label="down"
				className={props.className ? props.className : ""}
				onClick={onClick}
			>
				<Login style={{ fontSize: size }} />
			</Fab>
		</Tooltip>
	);
}
